import type { Role } from '../../pages/users/types/rbac';

/** Staff and clinical roles that may submit service requests from a client chart. */
const REQUEST_SERVICE_FROM_CHART_ROLES: readonly Role[] = [
  'unify-admin',
  'unify-assistant',
  'practice-owner',
  'practice-admin',
  'practice-assistant',
  'provider',
  'supervisor',
];

/** True when the user may open "Request a Service" on a client chart. */
export function canRequestServiceFromChart(role: Role): boolean {
  return REQUEST_SERVICE_FROM_CHART_ROLES.includes(role);
}
